import React, { useContext } from 'react';
import { ProfileContext } from '../contexts/ProfileContext';
import FullPagePopup from '../components/popups/fullPagePopup';
import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router-dom';

export default function ExampleVideo() {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const vimeoId = searchParams.get('vimeoId');

  const [profile] = useContext(ProfileContext);
  const { profileTypeData: { exampleVideo } = {} } = profile;

  const videoUrl = vimeoId || exampleVideo?.video?.[i18n.language];

  if (!videoUrl) return <Navigate to="/my-profile" />;

  return (
    <FullPagePopup closeLink={-1}>
      {!vimeoId && (
        <video
          src={process.env.REACT_APP_AWS_URL + exampleVideo?.video?.[i18n.language]}
          controls
          autoPlay
          className="w-full h-full object-cover"
        />
      )}

      {vimeoId && (
        <div
          style={{
            position: 'relative',
            borderRadius: '5px',
            overflow: 'hidden'
          }}>
          <div className="container mx-auto max-w-md max-h-xl h-screen">
            <iframe
              src={`https://player.vimeo.com/video/${vimeoId}?autoplay=1`}
              style={{ top: 0, left: 0, width: '100%', height: '100%' }}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </FullPagePopup>
  );
}
